module.exports = __webpack_public_path__ + "static/img/green.463090b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/green.png
// module id = 4TGT
// module chunks = 0